import { SagaIterator } from '@redux-saga/core'
import { PayloadAction } from '@reduxjs/toolkit'
import { call, takeEvery } from 'redux-saga/effects'

import { organizationCreate } from 'features/organization/api'
import { organizationActions } from 'features/organization/store/organization.slice'
import { OrganizationDetailsRequest } from 'features/organization/types'

// Worker saga: handles the actual API call
function* onCreateOrganization(action: PayloadAction<OrganizationDetailsRequest>): SagaIterator {
  try {
    const res = yield call(organizationCreate, action.payload)
    console.log(res, 'ress')
  } catch (error) {
    console.log(error, 'err')
  }
}

// Watcher saga: watches for organizationCreation actions
export function* organizationWatcherSaga(): SagaIterator {
  // Use the action type string here
  yield takeEvery(organizationActions.organizationCreation.type, onCreateOrganization)
}

export default organizationWatcherSaga
